
export var DISNEY: any[] = [
    {
        providerId: "c38caa90-f019-11e7-b791-2702c92c19de",
        providerName: "Majestic",
        nameAdapter: "Majestic_Disney",
        searchId: "258643437165150655",
        id: "6451",
        title: "DISNEYS POP CENTURY RESORT HOTEL",
        description: null,
        categoryId: 12,
        productId: "6451",
        origin: null,
        destination: "ORL",
        dateIni: "2018-07-02",
        dateEnd: "2018-07-08",
        serviceResponse: null,
        qtyPax: 0,
        others: {
            maxRequestTimeOnSeconds: 60,
            serialized: false
          },
        additionalInfo: {
          favorite: false,
          searchId: "258643437165150655",
          promo: true,
          stars: "3",
          id: "6451",
          name: "DISNEYS POP CENTURY RESORT HOTEL",
          description: "Lleva a tu familia a viajar en el tiempo. En el Disney's Pop Century Resort, puedes remontar a tu familia en el tiempo para que recuerde décadas del siglo veinte. Desde tocadiscos y bolos hasta computadoras portátiles y teléfonos celulares, los objetos de recuerdo, la moda y las frases hechas que definieron el siglo veinte, te rodean en este Value Resort de 2.880 habitaciones. Cada instalación es una gigantesca \"cápsula del tiempo\" de la cultura pop que te llevará al mundo de los recuerdos.",
          images: [
            {
              description: "image_DISNEYS POP CENTURY RESORT HOTEL",
              image: "https://dam.ngenespanol.com/wp-content/uploads/2019/01/Walt-Disney-world.png",
              thumbnail: "https://dam.ngenespanol.com/wp-content/uploads/2019/01/Walt-Disney-world.png"
            }
          ],
          location: "ORLANDO-FLORIDA-USA",
          address: "1050 CENTURY DRIVE",
          phone: "407-938-4000",
          arrival: "15:00",
          departure: "11:00",
          latitude: "28.3504067",
          longitude: "-81.5429644",
          specialNotes: null,
          conditions: null,
          reserveMultiHab: false,
          roomsQty: 4,
          rooms: [
            {
              description: "",
              roomType: "STANDARDROOM - MEGADISPO",
              roomId: 469,
              bookParam: null,
              optionId: null,
              accomodationId: 139,
              maxPax: "2",
              optionNightsNetTotal: null,
              netPrice: null,
              optionCommissionValue: null,
              refPrice: 196.60666666667,
              optionFreeNightsTotal: null,
              optionCommissionPercentage: null,
              nights: 6,
              specialPrice: [],
              optionStatus: null,
              images: "hola.jpg"
            }
          ]
        }
    }
  ];